import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';

import WeatherReportSummary from './components/summary';
import WeatherReportDetails from './components/details';
import WeatherReportError from './components/error';

const WeatherReport = ({
  endpoint,
  feedKey,
  labelPastSnowball,
  labelTodaySnowball,
  labelTonightsSnowball,
  labelWindSpeed,
  mainHeading,
  headingLookingAhead,
  buttonUrl,
  buttonLabel,
  unavailableDataPointMessage,
  unavailableMessage,
  unavailableLink
}) => {
  const [report, setReport] = useState({});
  const [error, setError] = useState(false);

  const unavailableLinkFormated = useMemo(
    () => (unavailableLink ? JSON.parse(unavailableLink) : {}),
    [unavailableLink]
  );

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await Axios({
        method: 'GET',
        url: endpoint,
        params: {
          mountain: feedKey
        }
      });

      setReport(data);
    };

    fetchData().catch(err => {
      setError(true);
    });
  }, [endpoint, feedKey]);

  return (
    <>
      {!error ? (
        <>
          {!!report.forecast && (
            <WeatherReportSummary
              title={mainHeading}
              labelPastSnowball={labelPastSnowball}
              labelTodaySnowball={labelTodaySnowball}
              labelTonightsSnowball={labelTonightsSnowball}
              labelWindSpeed={labelWindSpeed}
              data={report.forecast}
            />
          )}

          {!!report.forecast && (
            <WeatherReportDetails
              data={report.forecast}
              poweredByImg={report.poweredByImg}
              poweredByLabel={report.poweredByLabel}
              viewFullForecastUrl={report.viewFullForecastUrl}
              title={headingLookingAhead}
              labelPastSnowball={labelPastSnowball}
              labelTodaySnowball={labelTodaySnowball}
              labelTonightsSnowball={labelTonightsSnowball}
              labelWindSpeed={labelWindSpeed}
              buttonUrl={buttonUrl}
              buttonLabel={buttonLabel}
              unavailableDataPointMessage={unavailableDataPointMessage}
            />
          )}
        </>
      ) : (
        <WeatherReportError
          message={unavailableMessage}
          link={unavailableLinkFormated}
        />
      )}
    </>
  );
};

WeatherReport.propTypes = {
  endpoint: PropTypes.string.isRequired,
  feedKey: PropTypes.string.isRequired,
  labelPastSnowball: PropTypes.string.isRequired,
  labelTodaySnowball: PropTypes.string.isRequired,
  labelTonightsSnowball: PropTypes.string.isRequired,
  labelWindSpeed: PropTypes.string.isRequired,
  mainHeading: PropTypes.string,
  headingLookingAhead: PropTypes.string,
  buttonUrl: PropTypes.string,
  buttonLabel: PropTypes.string,
  unavailableDataPointMessage: PropTypes.string.isRequired,
  unavailableMessage: PropTypes.string.isRequired,
  unavailableLink: PropTypes.string
};

export default WeatherReport;
